<template> </template>

<script>
export default {
  name: 'Redirect',
  beforeCreate() {
    let toPath = this.$route.query.toPath
    if (toPath) {
      this.$router.push({ path: toPath })
    }
  }
}
</script>

<style scoped></style>
